module.exports = __webpack_public_path__ + "media/video2.282b9ed5.mp4";